import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_shell/smart-product-displays-solutions-guide.md")({
  beforeLoad: () => {
    throw redirect({
      to: "/internal-docs",
      hash: "smart-product-displays-solutions-guide",
      replace: true,
    });
  },
});
